import type { IxcProspectusV1ProspectusJobKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const PROSPECTUS_JOB_BASE_PATH = getResolvedPath('/clearing/vendor/beta-nxt/prospectus-job');

export const getProspectusJobPath: EntityPathBuilder<IxcProspectusV1ProspectusJobKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return PROSPECTUS_JOB_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.jobId) {
        return undefined;
      }

      return getResolvedPath(`${PROSPECTUS_JOB_BASE_PATH}/$jobId`, context.keys);
    }
  }
};

export function getProspectusJobDetailPath(jobId: string | undefined) {
  if (!jobId) {
    return undefined;
  }

  return getProspectusJobPath({ kind: 'detail', keys: { jobId } });
}
